import { lowerFirst } from 'lodash';

export const getFieldName = (props, t) =>
  props.transactionType
    ? props.rule[props.transactionType].objectMappings.find(
        m => m.object.index === props.objectIndex
      ).object.name
    : t(`positionTemplateRule.${lowerFirst(props.fieldName)}`);
